export default __webpack_public_path__ + "static/media/ClubGreenCheck.a4506ca4.svg";